import { Component, HostBinding, inject, Input } from '@angular/core'
import { NgOptimizedImage } from '@angular/common'
import { CookieKey, ED_INJECT_LOCALE_ID } from 'src/server/server.data'
import { CookieInterface } from 'src/tools/cookie.tools'
import { i18nPath } from 'src/tools/i18n.tools'

@Component({
  standalone: true,
  imports: [NgOptimizedImage],
  selector: 'app-i18n-selector',
  templateUrl: './i18n-selector.component.html',
  styleUrl: './i18n-selector.component.sass'
})
export class I18nSelectorComponent {
  @HostBinding('class.language-picker--active') isActive = false
  @HostBinding('class') get classes () {
    return `e--type-${this.type}`
  }
  @Input() type: 'solid' |'bordered' = 'solid'

  protected readonly Object = Object
  protected locale = inject(ED_INJECT_LOCALE_ID) as 'de' | 'en' | 'es' | 'fr' | 'zh'
  protected locales = {
    de: 'Deutsch',
    en: 'English',
    es: 'Español',
    fr: 'Français',
    zh: '汉语',
  }
  protected path = i18nPath()

  select (locale: string) {
    CookieInterface.set(CookieKey.I18nSelection, locale)
  }
}
